export const QR_GENERATION_ERROR = 'qr-generation-error'


// WEBPACK FOOTER //
// ./src/components/Modal/constants.js